var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"bg",staticClass:"left-right-content-modules container-fluid border-bottom lazy",class:{'left':_vm.left},attrs:{"data-background-image":_vm.bg}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }